export default __webpack_public_path__ + "static/media/ForensicLedgerHeader.ccad884c.png";